import React from "react";
import Header from "../../Home/Header";
import Footer from "../../Home/Footer";
import DefiWalletHero from "./DefiWalletHero";
import DeFiService from "./DeFiService";
import StunningFeatures from "./StunningFeatures";
import GetSwithDeFiW from "./GetSwithDeFiW";
import Fintech from "./Fintech";
import WhyChoose from "../NFT Wallet/WhyChoose";

function DefiWallet() {
  return (
    <div>
      <Header />
      <DefiWalletHero />
      <DeFiService />
      <StunningFeatures />
      <GetSwithDeFiW />
      {/* <Fintech /> */}
      <WhyChoose />
      <Footer />
    </div>
  );
}

export default DefiWallet;
